import type { MachineDatasheet } from '@indutrust/machine-model';

type DatasheetSyncListener = (
  machineParkId: number,
  datasheet: MachineDatasheet
) => void;

/**
 * Demo/MSW bridge: factory machine-park datasheet uploads notify the
 * machine-catalog handlers so pending catalog entries receive the same
 * datasheet metadata (enabling admin Analyze datasheets).
 */
const listeners: DatasheetSyncListener[] = [];

/** Registers a sync listener; returns an unsubscribe function. */
export function onMachineParkDatasheetUploaded(
  listener: DatasheetSyncListener
): () => void {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx !== -1) {
      listeners.splice(idx, 1);
    }
  };
}

/** Notifies listeners that a datasheet was attached to a factory machine. */
export function notifyMachineParkDatasheetUploaded(
  machineParkId: number,
  datasheet: MachineDatasheet
): void {
  for (const listener of listeners) {
    listener(machineParkId, datasheet);
  }
}
